// @flow

import React from 'react';
import 'rc-tooltip/assets/bootstrap.css';
import './Tooltip.scss';
import { default as RcTooltip } from 'rc-tooltip';

type Props = {
  children: any,
  content: any,
}

const Tooltip = (props: Props) => (
  <RcTooltip
    placement="top"
    overlay={props.content}
    mouseEnterDelay={0.1}
    align={{offset: [0, 4]}}
  >
    {props.children}
  </RcTooltip >
);

export default Tooltip;
